// extracted by mini-css-extract-plugin
module.exports = {"container":"e_zp","buttonPrev":"e_Ap","buttonNext":"e_Bp","hidden":"e_Cp","iconPrev":"e_Dp","iconNext":"e_Ep","scrollView":"e_Fp","card":"e_Gp","scroller":"e_Hp"};